import { render } from "./specialB.vue?vue&type=template&id=97a09810&scoped=true"
import script from "./specialB.vue?vue&type=script&lang=js"
export * from "./specialB.vue?vue&type=script&lang=js"

import "./specialB.vue?vue&type=style&index=0&id=97a09810&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a09810"]])

export default __exports__